import {
  CentraCheckoutApiMapperOptions,
  CentraCheckoutApiMapperOptionsDimensionInfo,
} from "@made-people/grease-centra";
import { FrontendContextV1 } from "@made-people/nestjs-bff-service";
import { AllocationRuleInfo } from "../../../../components/features/delivery-status/out-of-stock-information";

export type MmMapperContext = CentraCheckoutApiMapperOptions["context"] & {
  allocationRule?: AllocationRuleInfo;
};

export const productImageKey = "original";

// Maybe this should be transferred in a json response
export const productUriField = "variant_uri_en";

export const dimensionInfo: CentraCheckoutApiMapperOptionsDimensionInfo[] = [
  { key: "waist-size", label: "Item_Dimension_Waist_Size" },
  { key: "cup-size", label: "Item_Dimension_Cup_Size" },
];

export const productOptions: CentraCheckoutApiMapperOptions["productOptions"] =
  {
    productImageKey,
    itemDimensionParseOptions: {
      dimensionInfo,
    },
    uriField: productUriField,
  };

export const getCentraCheckoutApiMapperOptions = (
  frontendContext: FrontendContextV1,
  allocationRule?: AllocationRuleInfo,
): CentraCheckoutApiMapperOptions => {
  return {
    productOptions,
    context: {
      currencyCode: frontendContext.currency.currency!,
      countryCode: frontendContext.country!,
      allocationRule,
    } as CentraCheckoutApiMapperOptions["context"],
  };
};
